import type { DashboardSidebarProps } from '@frontend/pages/dashboard/types';
import AccountSection from './components/AccountSection';
import DashboardNavSection from './components/DashboardNavSection';
import ServiceNavSection from './components/ServiceNavSection';
import ProjectTreeSection from './components/ProjectTreeSection';
import FeedbackSection from './components/FeedbackSection';

export default function DashboardSidebar({
	userName,
	environmentLabel,
	showHotloadingControl,
	stackUiPhase,
	routeMode,
	routeToggleEnabled,
	routeToHotAllowed,
	routeBusy,
	stackBusy,
	hotloadingError,
	sidebarHidden,
	selected,
	accessibleEcosystems,
	ecosystemDefs,
	projectsByEcosystem,
	expandedEcosystems,
	onToggleSidebar,
	onSelectHome,
	onSelectSystemAdmin,
	onSelectRealmAdmin,
	onSelectEcosystemAdmin,
	onSelectProjectAdmin,
	onSelectSettings,
	onSelectFeedback,
	onSelectEcosystem,
	onSelectProject,
	onToggleEcosystemExpanded,
	onHotStackToggle,
	onHotRouteToggle,
	onLogout,
	canSeeSystemAdmin,
	canSeeRealmAdmin,
	canSeeEcosystemAdmin,
	canSeeProjectAdmin,
}: DashboardSidebarProps) {
	return (
		<aside className={`tree-dashboard-sidebar ecosystem-card ${sidebarHidden ? 'is-hidden' : ''}`}>
			<button
				type="button"
				className="tree-dashboard-rail-handle"
				onClick={onToggleSidebar}
				aria-label={sidebarHidden ? 'Show left navigation' : 'Hide left navigation'}
			>
				{sidebarHidden ? '▸' : '◂'}
			</button>

			{!sidebarHidden ? (
				<>
					<div className="tree-dashboard-app-title">Patriotic Projects</div>
					<AccountSection
						userName={userName}
						environmentLabel={environmentLabel}
						showHotloadingControl={showHotloadingControl}
						stackUiPhase={stackUiPhase}
						routeMode={routeMode}
						routeToggleEnabled={routeToggleEnabled}
						routeToHotAllowed={routeToHotAllowed}
						routeBusy={routeBusy}
						stackBusy={stackBusy}
						hotloadingError={hotloadingError}
						selected={selected}
						onSelectSettings={onSelectSettings}
						onHotStackToggle={onHotStackToggle}
						onHotRouteToggle={onHotRouteToggle}
						onLogout={onLogout}
					/>

					<DashboardNavSection
						selected={selected}
						homeEcosystemId={accessibleEcosystems[0] || ''}
						canSeeSystemAdmin={canSeeSystemAdmin}
						canSeeRealmAdmin={canSeeRealmAdmin}
						canSeeEcosystemAdmin={canSeeEcosystemAdmin}
						canSeeProjectAdmin={canSeeProjectAdmin}
						onSelectHome={onSelectHome}
						onSelectSystemAdmin={onSelectSystemAdmin}
						onSelectRealmAdmin={onSelectRealmAdmin}
						onSelectEcosystemAdmin={onSelectEcosystemAdmin}
						onSelectProjectAdmin={onSelectProjectAdmin}
					/>

					<ServiceNavSection />

					<ProjectTreeSection
						selected={selected}
						accessibleEcosystems={accessibleEcosystems}
						ecosystemDefs={ecosystemDefs}
						projectsByEcosystem={projectsByEcosystem}
						expandedEcosystems={expandedEcosystems}
						onToggleEcosystemExpanded={onToggleEcosystemExpanded}
						onSelectEcosystem={onSelectEcosystem}
						onSelectProject={onSelectProject}
					/>

					<FeedbackSection selected={selected} onSelectFeedback={onSelectFeedback} />
				</>
			) : null}
		</aside>
	);
}
